<template>
  <NuxtLayout
    name="main-view"
    :hasBackButton="true"
    :headline="$t('dbc-personal-data')"
  >
    <div
      v-if="successMessage"
      class="grid grid-cols-card-layout gap-2xs max-tablet:flex max-tablet:flex-col"
    >
      <DbcBanner
        severity="success"
        :has-border="true"
        :message="successMessage"
        :life="3000"
        class="mb-xs"
        role="alert"
        aria-live="assertive"
        @life-end="removeUpdateQueryParam()"
      />
    </div>
    <div v-if="data">
      <div
        class="grid grid-cols-card-layout mb-xs gap-2xs max-tablet:flex max-tablet:flex-col"
      >
        <CardEdit
          :title="$t('dbc-label-email')"
          :subtitle="data.mail"
          @edit="
            $router.push({
              path: usePagePath('data-update-email'),
            })
          "
        />
        <CardEdit
          :title="$t('dbc-label-mobile-phone')"
          :subtitle="data.mobile"
          @edit="
            $router.push({
              path: usePagePath('data-update-phone'),
            })
          "
        />
        <CardEdit
          :title="$t('dbc-label-password')"
          subtitle="********"
          @edit="
            $router.push({
              path: usePagePath('data-update-password'),
            })
          "
        />
      </div>
      <div
        class="grid grid-cols-card-layout gap-2xs auto-rows-fr max-tablet:flex max-tablet:flex-col"
      >
        <Card :pt="simpleCardPassthrough">
          <template #title
            >{{ $t('dbc-contact-b2c-input-name-label') }}
          </template>
          <template #subtitle>
            {{ data.firstName }} {{ data.lastName }}
          </template>
        </Card>
        <Card v-if="data.birthdate" :pt="simpleCardPassthrough">
          <template #title>{{ $t('dbc-label-birthdate') }} </template>
          <template #subtitle>
            {{ dayjs(data.birthdate).format('D[.] MMMM YYYY') }}
          </template>
        </Card>
        <DbcBanner
          severity="info"
          :has-border="true"
          :message="$t('dbc-text-personal-data-hint')"
          class="min-h-[80px] [@media(max-width:1100px)]:col-span-2"
        />
      </div>
    </div>
  </NuxtLayout>
</template>

<script setup lang="ts">
import dayjs from 'dayjs'
import 'dayjs/locale/de'
import { useCustomerStore } from '../../../../stores/customer'

const route = useRoute()

const customerStore = useCustomerStore()
const { data } = storeToRefs(customerStore)

const { t, locale } = useI18n()

dayjs.locale(locale.value)

const successMessage = ref('')
if (route.query.update) {
  successMessage.value = `${t(`dbc-label-${route.query.update}`)} ${t(
    'dbc-text-successfully-changed'
  )}`
}
</script>
